import { useTranslation } from "react-i18next";
import { useForm, ValidationError } from "@formspree/react";

export default function ContactSection() {
  const { t } = useTranslation("global");
  const [state, handleSubmit] = useForm("mbjnbvjy");

  if (state.succeeded) {
    return (
      <div
        id="contact"
        className="bg-gray-900 py-20 bg-[url('../assets/images/avion-last-section.png')] bg-cover bg-center bg-no-repeat"
      >
        <div className="flex items-center justify-center px-4">
          <div className="bg-gray-800/50 bg-blend-multiply shadow-md rounded-lg px-8 py-6 max-w-md backdrop-filter backdrop-blur-md w-full text-center">
            <p className="text-[#fcab21] font-bold text-lg">
              {t("Contact_Form.text")}
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      id="contact"
      className="bg-gray-900 py-20 bg-[url('../assets/images/avion-last-section.png')] bg-cover bg-center bg-no-repeat"
    >
      <div className="flex items-center justify-center px-4">
        <div className="bg-gray-800/50 bg-blend-multiply shadow-md rounded-lg px-8 py-6 max-w-md backdrop-filter backdrop-blur-md w-full">
          <h1 className="text-2xl font-bold text-center mb-6 text-gray-200">
            {t("ContactH.text")}
          </h1>

          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label
                htmlFor="email"
                className="block text-sm font-medium text-gray-300 mb-2"
              >
                {t("Email.text")}
              </label>
              <input
                id="email"
                type="email"
                name="email"
                className="w-full py-3 px-3 rounded-lg bg-gray-700/80 border border-gray-600 text-gray-400 font-semibold focus:border-[#fcab21] focus:outline-none"
                placeholder="flyxom@email.com"
                autoComplete="email"
                required
              />
              <ValidationError
                prefix="Email"
                field="email"
                errors={state.errors}
              />
            </div>

            <div className="mb-4">
              <label
                htmlFor="message"
                className="block text-sm font-medium text-gray-300 mb-2"
              >
                {t("Message.text")}
              </label>
              <textarea
                id="message"
                name="message"
                rows="5"
                className="w-full py-3 px-3 rounded-lg bg-gray-700/80 border border-gray-600 text-gray-400 font-semibold focus:border-[#fcab21] focus:outline-none resize-none"
                placeholder={t("Message.text")}
                required
              />
              <ValidationError
                prefix="Message"
                field="message"
                errors={state.errors}
              />
            </div>

            <button
              type="submit"
              disabled={state.submitting}
              className="w-full bg-[#fcab21] hover:bg-yellow-600 text-white font-bold py-3 px-6 rounded-lg shadow-xl disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200"
            >
              {state.submitting ? "Sending..." : t("Send.text")}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
